/*
 * Announcements: the app wide ones in the admin settings, a team's or an event's in its settings,
 * the current ones on the dashboard and as a widget.
 * The front-end manifest, see lib/docs/extensions/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';
import { extensionOption } from '@lib/utils/eflib';

import de from './locale/de';
import en from './locale/en';

const page = () => import('./pages/Announcements.vue');
const list = () => import('./components/efAnnouncementList.vue');

export default defineExtension({
	name: 'announcements',
	locale: { de, en },
	slots: {
		'admin.settings': [{ id: 'announcements', icon: 'fa-bullhorn', group: 'communication', component: page }],
		'context.settings': [
			{
				id: 'announcements',
				icon: 'fa-bullhorn',
				group: 'communication',
				label: 'tabs.admin_settings.announcements',
				contexts: ['team', 'event'],
				when: ({ context }) => extensionOption('announcements', context),
				// The read guard of its routes on the record
				ability: 'read',
				component: page,
			},
		],
		// The current ones of the active context, above the app's dashboard
		dashboard: [{ id: 'announcements', order: 0, component: list }],
	},
	widgets: {
		'announcements-widget': () => import('./components/AnnouncementsWidget.vue'),
	},
});
